import React from "react"
import { styled } from "@mui/material/styles"
import { Link as RouterLink } from "react-router-dom"
import { Grid, Container, Link, Box, Typography } from "@mui/material"
import TextInformationText from "atoms/text/TextInformationText"
import InformationDataja from "assets/locales/ja/information/InformationData.json"
import TopLinkCardArrow from "atoms/button/TopLinkCardArrow"
import { FormattedMessage } from "react-intl"
import { getLocaleJaOrEnInitialUpper } from "locale.js"

const RootContainer = styled(Container)(({ theme }) => ({
  padding: "30px 4px 50px",
  [theme.breakpoints.down("sm")]: {
    margin: "0 auto",
    width: "calc( 100% - ( 16px * 2 ) )",
  },
}))

const InnerGrid = styled(Grid)(({ theme }) => ({
  maxWidth: "700px",
  margin: "0 auto",
}))

const NoticeInnerBox = styled(Box)(({ theme }) => ({
  margin: "10px 0 0",
  padding: 0,
}))

const NoticeList = styled(Box)(({ theme }) => ({
  padding: "5px 0 0 0",
}))

const DateText = styled(Typography)(({ theme }) => ({
  fontWeight: "600",
}))

const NoticeText = styled(Typography)(({ theme }) => ({
  padding: "10px 0",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "14px",
  lineHeight: 1.6,
  letterSpacing: "normal",
  color: "#333",
  whiteSpace: "pre-wrap",
}))

const NoticeNewIcon = styled("span")(({ theme }) => ({
  display: "inline-block",
  width: "30px",
  height: "16px",
  margin: "0 0 0 10px",
  lineHeight: "16px",
  color: "#fff",
  textAlign: "center",
  backgroundColor: "#ab1b1b",
  borderRadius: "4px",
  fontSize: "11px",
  fontWeight: "normal",
}))

const InfoLink = styled(Link)(({ theme }) => ({
  display: "block",
  padding: "0 17px 17px",
  textAlign: "right",
}))

const InfoLinkText = styled(Box)(({ theme }) => ({
  padding: "0 8px 0 0",
  fontSize: "14px",
}))

const TopInformation = () => {
  let informationDataLast

  informationDataLast = InformationDataja.concat()
    .sort((before, after) => before.newsId - after.newsId)
    .pop()
  const dataGa = "information" + getLocaleJaOrEnInitialUpper()
  return (
    <RootContainer>
      <InnerGrid>
        <Grid item xs={12} md={12}>
          <TextInformationText>
            <FormattedMessage id="TopInformation.Title" />
          </TextInformationText>
        </Grid>
        <Grid item xs={12} md={12}>
          {informationDataLast && (
            <NoticeList>
              <NoticeInnerBox component="dl">
                <DateText component="dt" id="TopInformationsortmessage">
                  {informationDataLast.infoDateText}
                </DateText>
                {informationDataLast.infoText &&
                  informationDataLast.infoText.map((text, textindex) => (
                    <NoticeText key={textindex} component="dd">
                      {text}
                    </NoticeText>
                  ))}
              </NoticeInnerBox>
            </NoticeList>
          )}
        </Grid>
        <Grid item xs={12} md={12}>
          <InfoLink
            component={RouterLink}
            to="/information"
            id="information"
            data-ga={dataGa}
            underline="hover"
          >
            <InfoLinkText component="span">
              <FormattedMessage id="TopInformation.InformationSummaryLink" />
            </InfoLinkText>
            <TopLinkCardArrow />
          </InfoLink>
        </Grid>
      </InnerGrid>
    </RootContainer>
  )
}

export default TopInformation
